import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import NetworkBar from '../../../../NetworkBar';
import Button from '../../../../Button';
import { useBodyScrollLock } from '@wix/da-ds/pkg/hooks/useBodyScrollLock';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import CloseSmall from '@wix/da-ds/pkg/Icons/CloseSmall';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiData } from '@wix/da-bi/pkg/events';
import SubmitMenu from '../SubmitMenu';
import s from './BurgerMenuContent.scss';
var BurgerMenuContent = function (_a) {
    var className = _a.className, isOpen = _a.isOpen, isLegacyHeader = _a.isLegacyHeader, activeMainMenuItem = _a.activeMainMenuItem;
    var t = useTranslation().t;
    var _b = useBodyScrollLock(), onLock = _b.onLock, onUnlock = _b.onUnlock, setScrollableRef = _b.setScrollableRef;
    var _c = useState(false), isSubmitMenuOpened = _c[0], setSubmitMenuOpened = _c[1];
    useEffect(function () {
        if (isOpen) {
            onLock();
            setSubmitMenuOpened(false);
        }
        else {
            onUnlock();
            setSubmitMenuOpened(false);
        }
    }, [isOpen, onLock, onUnlock]);
    return (React.createElement("div", { className: classnames(s['root'], isSubmitMenuOpened && s['submit'], className), "aria-hidden": !isOpen },
        React.createElement("div", { className: s['header'] },
            !isSubmitMenuOpened && (React.createElement(Button, { onClick: function () { return setSubmitMenuOpened(true); }, view: "b1-1", className: s['submit-button'], fullWidth: false, tabIndex: isOpen ? 0 : -1, biData: BiData({
                    evid: 703,
                    sectionname: 'hamburger',
                }) }, t('common.submit'))),
            isSubmitMenuOpened && (React.createElement(PlainButtonOrLink, { onClick: function () { return setSubmitMenuOpened(false); }, className: classnames(s['submit-button'], s['submit-close']) },
                React.createElement(CloseSmall, { className: s['close'], size: IconSize.TINY })))),
        React.createElement("div", { className: s['scrollable-content'], ref: setScrollableRef },
            !isSubmitMenuOpened && (React.createElement(NetworkBar, { isVisible: isOpen, selectedItem: activeMainMenuItem })),
            isSubmitMenuOpened && (React.createElement(SubmitMenu, { isOpen: isSubmitMenuOpened, isLegacyHeader: isLegacyHeader })))));
};
BurgerMenuContent.displayName = 'BurgerMenuContent';
export default BurgerMenuContent;
//# sourceMappingURL=BurgerMenuContent.js.map